import * as classnames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { StaticGoogleMap, Marker } from 'react-static-google-map';
import { stylesToString } from '../utils/stylesToString';
import MapTypeStyle = google.maps.MapTypeStyle;

export enum MarkerColors {
    BLACK = 'black',
    BROWN = 'brown',
    GREEN = 'green',
    PURPLE = 'purple',
    YELLOW = 'yellow',
    BLUE = 'blue',
    GRAY = 'gray',
    ORANGE = 'orange',
    RED = 'red',
    WHITE = 'white'
}

export interface IMarkers {
    latitude: number;
    longitude: number;
    icon?: string;
    color?: MarkerColors | number;
    label?: string;
}

export interface IStaticMap {
    className?: string;
    apiKey: string;
    size: string;
    markers: IMarkers[];
    zoom?: number;
    styles?: MapTypeStyle[];
    WrapperElement?: React.ElementType;
    alt?: string;
    scale?: '1' | '2' | '4' | 1 | 2 | 4;
}

const StaticMapWrapper = styled.div`
    margin: auto;
    padding: 20px;
`;

export const StaticMap = (props: IStaticMap) => {
    const classNames = classnames('elc-static-maps', 'js-static-maps', props.className);
    const WrapperElement = props.WrapperElement || StaticMapWrapper;

    const { apiKey, size, markers, zoom, styles, alt, scale } = props;

    return (
        <WrapperElement className={classNames}>
            <StaticGoogleMap
                size={size}
                apiKey={apiKey}
                zoom={zoom}
                style={styles ? stylesToString(styles) : ''}
                alt={alt}
                scale={scale}
            >
                {markers.map(marker => (
                    <Marker
                        key={`${marker.latitude},${marker.longitude}`}
                        location={`${marker.latitude},${marker.longitude}`}
                        iconURL={marker.icon}
                        color={marker.color}
                        label={marker.label}
                    />
                ))}
            </StaticGoogleMap>
        </WrapperElement>
    );
};
